// extracted by mini-css-extract-plugin
export var chevron = "_3f-2";
export var chevronCollapsed = "_3f-3";
export var collapsibleHeader = "_3f-1";
export var container = "_3f-0";